import { render, staticRenderFns } from "./modelContractMpago.vue?vue&type=template&id=198e33d7&"
import script from "./modelContractMpago.vue?vue&type=script&lang=js&"
export * from "./modelContractMpago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports